import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from 'store/actions/index';
import { injectIntl } from 'react-intl';
import { getSortOptionsForApp } from "Flow2/components/CustomCollections/CustomDataUtil/CustomDataUtil";
import * as DataUtil from "Flow2/components/CustomCollections/CustomDataUtil/CustomDataUtil";

class CustomFlexController extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    setDefaultOptions = () => {
        let defaultOptions = [
            { value: 'id|DESC', displayValue: this.props.intl.formatMessage({ id: "page.cliplist.sorting.sorting" }) },
            { value: getSortOptionsForApp('rechte_produktionsdatum|DESC', this.props.customConfigClipInfoForApp), displayValue: this.props.intl.formatMessage({ id: "page.cliplist.sorting.dateDESC" }) },
            { value: getSortOptionsForApp('rechte_produktionsdatum|ASC', this.props.customConfigClipInfoForApp), displayValue: this.props.intl.formatMessage({ id: "page.cliplist.sorting.dateASC" }) },
            { value: getSortOptionsForApp('created|DESC', this.props.customConfigClipInfoForApp), displayValue: this.props.intl.formatMessage({ id: "page.cliplist.sorting.uploadDESC" }) },
            { value: getSortOptionsForApp('created|ASC', this.props.customConfigClipInfoForApp), displayValue: this.props.intl.formatMessage({ id: "page.cliplist.sorting.uploadASC" }) },
            { value: 'media|DESC', displayValue: this.props.intl.formatMessage({ id: "page.cliplist.sorting.type" }) },
        ];

        return defaultOptions;
    }

    setFlexSortDropDown = () => {
        let ddSortOptions = null;
        const { metadata } = this.props.customFlexAppConfig;
        if (metadata) {
            let sortOptions = metadata.filter(item => (item.params && item.params.sortoption) ? true : false);
            if (sortOptions && sortOptions.length > 0 && !DataUtil.isPMDB()) {
                let options = [{ value: 'id|DESC', displayValue: this.props.intl.formatMessage({ id: "page.cliplist.sorting.sorting" }) }];
                if (DataUtil.isFrancetv()) {
                    options = [
                        { value: 'id|DESC', displayValue: this.props.intl.formatMessage({ id: "page.cliplist.sorting.orderfront" }) },
                        { value: getSortOptionsForApp('created|DESC', this.props.customConfigClipInfoForApp), displayValue: this.props.intl.formatMessage({ id: "page.cliplist.sorting.uploadDESC" }) },
                        { value: getSortOptionsForApp('created|ASC', this.props.customConfigClipInfoForApp), displayValue: this.props.intl.formatMessage({ id: "page.cliplist.sorting.uploadASC" }) },
                    ];
                }
                sortOptions.forEach((item, i) => {
                    let display = this.props.intl.formatMessage({ id: `${item.intl}` });
                    let intl_desc = item.params.sortoption === "custom"
                        ? this.props.intl.formatMessage({ id: `page.cliplist.sorting.${item.field}DESC` })
                        : `${display} DESC`;
                    let intl_asc = item.params.sortoption === "custom"
                        ? this.props.intl.formatMessage({ id: `page.cliplist.sorting.${item.field}ASC` })
                        : `${display} ASC`;
                    options.push({ value: `${item.field}|DESC`, displayValue: intl_desc },
                        { value: `${item.field}|ASC`, displayValue: intl_asc });
                });
                if (!DataUtil.isFrancetv()) options.push({ value: 'media|DESC', displayValue: this.props.intl.formatMessage({ id: "page.cliplist.sorting.type" }) });
                ddSortOptions = options;
            } else {
                ddSortOptions = this.setDefaultOptions();
            }
        }
        this.props.getCustomFlexAppConfig({ ddSortOptions });
    }

    setFlexViewList = () => {
        if (DataUtil.isFrancetv()) {
            const { metadata } = this.props.customFlexAppConfig;

            if (metadata) {
                let viewListItems = metadata.filter(item => (item.params && item.params.viewlist) ? true : false);
                viewListItems = viewListItems.map(item => ({ ...item, viewListOrder: item.params.viewlist.order }))
                viewListItems = DataUtil.sortByProperty(viewListItems, { prop: "viewListOrder" });
                this.props.getCustomFlexAppConfig({ viewListItems });
            }
        }
    }

    getWorkflows = (action) => {
        let workflows = [];
        if (this.props.user.originalObject && this.props.user.originalObject.g) {
            let original = this.props.user.originalObject.g.get('workflows', { 'action': action });
            if (original) {
                for (let id in original) {
                    let name = original[id];
                    if (DataUtil.isFrancetv() && original[id] === 'notranscode') {
                        name = "Sans compression";
                    }
                    workflows.push({ name: name, id: id });
                }
            }
        }
        return workflows;
    }

    setWorkflows = () => {
        if (DataUtil.isFrancetv()) {
            let workflows = this.getWorkflows("upload");
            if (workflows) this.props.getCustomFlexAppConfig({ workflows });
            let transcodeWorkflows = this.getWorkflows("transcode");
            if (transcodeWorkflows) this.props.getCustomFlexAppConfig({ transcodeWorkflows });
        }
    }

    setInitData = () => {
        this.setFlexSortDropDown();
        this.setFlexViewList();
        this.setWorkflows();
    }

    componentDidMount() {
        this.setInitData();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.lg && (prevProps.lg != this.props.lg)) {
            this.setInitData();
        }
    }

    render() {
        return (<div></div>);
    }
}

const mapStateToProps = (state) => ({
    customFlexAppConfig: state.customData.customFlexAppConfig,
    user: state.auth.user,
    uiConfig: state.customData.customUiConfigForApp,
    lg: state.ui.language,
    customConfigClipInfoForApp: state.customData.customConfigClipInfoForApp,
    metadataConfig: state.metadata.config,
});
const mapDispatchToProps = (dispatch) => {
    return {
        getCustomFlexAppConfig: (option) => dispatch(actions.getCustomFlexAppConfig(option)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(CustomFlexController));